import React from "react";
import ReactHtmlParser from "react-html-parser";
import { useMainContext } from "../../context/MainContextProvider";
import outOfStock from "../../assets/images/out-of-gun-stock.png";
import loading from "../../assets/images/200.gif";

const Product = ({ product, handleProductClick }) => {
  const {
    getTag,
    getNameFromCategoryId,
    getNameFromSubCategoryId,
    getNameFromConditionId,
  } = useMainContext();

  const useProgressiveImage = (src) => {
    const [sourceLoaded, setSourceLoaded] = React.useState(null);

    React.useEffect(() => {
      let isMounted = true;
      const img = new Image();
      img.src = src;
      img.onload = () => {
        if (isMounted) {
          setSourceLoaded(src);
        }
      };

      return () => {
        isMounted = false;
      };
    }, [src]);

    return sourceLoaded;
  };

  // const useCompressedImage = (path) => {
  //   const supportedExtentions = ['.jpg', '.jpeg', '.png'];
  //   supportedExtentions.map(ext => {
  //     if (path.includes(ext)) {
  //           return path.replace(ext, `_400x300${ext}`);

  //     }
  //   });

  // }

  const {
    category,
    subCategory,
    name,
    image_small,
    description,
    price,
    condition,
    inStock,
  } = product;
  const bgImage = useProgressiveImage(image_small);

  return (
    <span className="post-card" onClick={() => handleProductClick(product)}>
      <header className="post-card-header">
        <div
          className="post-card-image"
          style={{
            backgroundColor: "transparent",
            backgroundSize: `${bgImage ? "cover" : "auto"}`,
            backgroundImage: `url(${
              !inStock ? outOfStock : bgImage || loading
            })`,
          }}
        ></div>
        <a
          className="post-card-title"
          style={{ fontSize: 15, display: "block", fontWeight: "bold" }}
          href={`/products/${getNameFromCategoryId(
            category
          )}/${getNameFromSubCategoryId(subCategory)}`}
        >
          {getTag(category, subCategory)}
        </a>
        <h2 className="post-card-title">{name}</h2>
      </header>
      <section className="post-card-excerpt">
        <>{ReactHtmlParser(description)}</>
      </section>
      <footer className="post-card-footer">
        {subCategory !== "categories_ammo" && (
          <div className="post-card-footer-left">
            <span style={{ fontWeight: "bold", fontSize: 11 }}>
              Condition: {getNameFromConditionId(condition)}
            </span>
          </div>
        )}
        <div className="post-card-footer-right" style={{ fontSize: 12 }}>
          <div>
            <span>{`£${price}`}</span>
          </div>
        </div>
      </footer>
    </span>
  );
};

export default Product;
